import axios from 'axios';
import DeathlyHallows from './LoadingScreen/DeathlyHallows';
import React, {useState} from 'react';
import wulfeWeddingConsts from './WulfeWedding.json';
import us from './images/Resized_IMG_8656_1711484527393.jpg';
import './GettingHitched.scss';

interface foundRecord {
    attending: boolean | string;
    code: string;
    name: string;
    partySize: number;
}

const {topLevelConsts} = wulfeWeddingConsts;

const GettingHitched = () => {
    const [userText, setUserText] = useState('');
    const [gateKeeper, setGateKeeper] = useState(topLevelConsts.empty);
    const [foundRecord, setFoundRecord] = useState<foundRecord>({
        "attending": "",
        "code": "",
        "name": "",
        "partySize": 1
    });
    const [rsvp, setRsvp] = useState('');
    const [error, setError] = useState('');

    const rsvpLookup = async (rsvpCode: string) => {
        setGateKeeper(topLevelConsts.loading);

        try {
            const usersRSVP = await axios.get(`http://localhost:3000/retrieveRSVP?rsvpCode=${rsvpCode}`);
            if (!!usersRSVP.data) {
                const {attending, code, name, partySize} = usersRSVP.data;
                setFoundRecord({
                    "attending": attending,
                    "code": code,
                    "name": name,
                    "partySize": partySize
                });
                const existingResponse = attending === 'true' ? topLevelConsts.yes : topLevelConsts.no;
                setGateKeeper(attending.length ? existingResponse : topLevelConsts.rsvp);
            } else {
                setError(topLevelConsts.notFound);
                setGateKeeper(topLevelConsts.empty)
            }
        } catch {
            setError(topLevelConsts.unexpected);
            setGateKeeper(topLevelConsts.empty);
        }
    };

    const submitRSVP = async (rsvpCode: string, rsvpResponse: string) => {
        setGateKeeper(topLevelConsts.loading);

        const convertedRsvpResponse = rsvpResponse === topLevelConsts.yes;

        try {
            await axios.patch(`http://localhost:3000/submitRSVP?rsvpCode=${rsvpCode}&rsvpResponse=${convertedRsvpResponse}`);
        } catch {
            setError(topLevelConsts.unexpected);
        } finally {
            if (error) {
                setError(topLevelConsts.unexpected);
                setGateKeeper(topLevelConsts.rsvp)
            } else {
                setGateKeeper(rsvp === topLevelConsts.yes ? topLevelConsts.yes : topLevelConsts.no)
            }
        }
    };

    const validateAndLookup = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const rsvpCodeVerification = !!userText.match(/[A-Z]{1}[a-z]{3,12}-[0-9]{4}/);

        if(rsvpCodeVerification) {
            await rsvpLookup(userText);
        } else {
            setError(topLevelConsts.copy.badCode)
        }
    };

    const handleRsvpChange = (event: React.ChangeEvent<HTMLInputElement>) => setRsvp(event.target.value);

    const inputLabelText = () => {
        if (error) {
            return error
        } else {
            return topLevelConsts.copy.requestForCode
        }
    };

  return (
    <div className='main-page'>
        {(gateKeeper === topLevelConsts.loading) && (
            <DeathlyHallows />
        )}
        {(gateKeeper === topLevelConsts.empty || gateKeeper === topLevelConsts.notFound) && (
            <>
                <h1>
                    We're Getting Married!
                </h1>
                <img alt="Isaiah and Ashley's Engagement" className='engagement-photo' src={us} />
                <form onSubmit={(event) => validateAndLookup(event)} className='input-block'>
                    <label className={error ? 'label-error' : ''} htmlFor='rsvp-code'>{inputLabelText()}</label>
                    <input className={error ? 'input-error' : ''} id='rsvp-code' onChange={(event) => setUserText(event.target.value)} required type='text' />
                    <button type="submit">
                        Accio Reservation
                    </button>
                </form>
            </>
        )}
        {gateKeeper === topLevelConsts.rsvp && (
            <div className='confirmed'>
                <h1>RSVP For:</h1>
                <h1>
                    {foundRecord.name}
                </h1>
                <h3>
                    Expected Attendees: {foundRecord.partySize}
                </h3>
                <div className='rsvp-form'>
                    <p>Are you able to attend?</p>

                    <form className='input-container' onSubmit={() => submitRSVP(foundRecord.code, rsvp)}>
                        <label className={rsvp === 'yes' ? 'active-label' : ''}>
                            <input checked={rsvp === 'yes'} type='radio' value={topLevelConsts.yes} onChange={(event) => handleRsvpChange(event)}/>
                            <span>Yes, we'll be there!</span>
                        </label>

                        <label className={rsvp === 'no' ? 'active-label' : ''}>
                            <input checked={rsvp === 'no'} type='radio' value={topLevelConsts.no} onChange={(event) => handleRsvpChange(event)} />
                            <span>No, sorry we can't make it</span>
                        </label>

                        <button type='submit'>
                            Send Your Owl
                        </button>
                    </form>
                </div>
            </div>
        )}
        {gateKeeper === topLevelConsts.yes && (
            <div className='yes-response'>
                <h1>
                    Let's Celebrate!
                </h1>

                <h3>
                    Event Details
                </h3>

                <div className="line" />

                <div className='details-container'>
                    <table>
                        <tbody>
                            <tr>
                                <th scope='row'>Time:</th>
                                <td>7-10 PM</td>
                            </tr>
                            <tr>
                                <th scope='row'>Address:</th>
                                <td>715 E Morgan Dr Gilbert, AZ 85295</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>If you would like to give a gift you can donate to our honeymoon here. If you can't, we'll be happy just to have you there.</p>
                </div>
            </div>
        )}
        {gateKeeper === topLevelConsts.no && (
            <div>
                <h1>
                    Bummer Deal Dude!
                </h1>
                <h3>But seriously, thanks for letting us know.</h3>
            </div>
        )}
    </div>
  );
}

export default GettingHitched;
